module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('SimpleHeader', {
    attrs: {
      "productInfo": _vm.productInfo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "login-inner flexcenter"
  }, [_c('div', {
    staticClass: "login-controls flexcenter"
  }, [_c('h3', {
    staticClass: "font22"
  }, [_vm._v("ソースネクストへサインイン")]), _vm._v(" "), _c('div', {
    staticClass: "mail flexcenter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "login-text",
    attrs: {
      "type": "text",
      "placeholder": "メールアドレス (マイページID)",
      "maxlength": "128"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.doLogin()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "password flexcenter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "login-text",
    attrs: {
      "type": "password",
      "placeholder": "パスワード (英数半角4～16文字)",
      "maxlength": "16"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.doLogin()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "enter",
    on: {
      "click": function($event) {
        return _vm.doLogin()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "static/images/icon/svg/ar_r_login.svg",
      "alt": "login"
    }
  })])]), _vm._v(" "), (_vm.message) ? _c('p', {
    staticClass: "login-error m0"
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "inline"
  }, [_vm._v("\n        ソースネクストアカウントをお持ちですか？\n      ")]), _vm._v(" "), _vm._m(1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "login-anchor",
    attrs: {
      "href": "https://www.sourcenext.com/sc/users/rem_form?PID=login_form",
      "target": "_blank"
    }
  }, [_vm._v("\n          メールアドレス、パスワードをお忘れですか？\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "inline"
  }, [_c('span', [_vm._v(">")]), _vm._v(" "), _c('a', {
    staticClass: "login-anchor",
    attrs: {
      "href": "https://www.sourcenext.com/sc/users/user_reg_auth",
      "target": "_blank"
    }
  }, [_vm._v("\n          今すぐ作成\n        ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-961030bc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-961030bc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 881
// module chunks = 1